export const business = (state) => state.business
export const allBusinessPermission = (state) => state.allBusinessPermission
export const getBusinessPermission = (state) => state.getBusinessPermission